import React from 'react';
import { mui } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import { getConstraintType } from '../../optimizer-utils/constraint-type';
import Bounds from '../bounds';
import SharedConstraintFields from '../shared-fields';
import Target from '../target';

type NetLeverageConstraintProps = {
  params: types.optimizer.ConstraintDraft;
  setParams: (_params: types.optimizer.ConstraintDraft) => void;
  readOnly: boolean;
  validationDef: types.common.ValidationErrors;
};

const NetLeverageConstraint = ({ params, setParams, readOnly, validationDef }: NetLeverageConstraintProps) => {
  const [showMore, setShowMore] = React.useState(false);

  const form = () => {
    if (getConstraintType(params) == 'BOUNDS') {
      if (showMore) {
        return (
          <Bounds params={params} setParams={setParams} readOnly={readOnly} validationDef={validationDef}>
            <SharedConstraintFields
              params={params}
              setParams={setParams}
              readOnly={readOnly}
              validationDef={validationDef}
            />
          </Bounds>
        );
      }

      return <Bounds params={params} setParams={setParams} readOnly={readOnly} validationDef={validationDef} />;
    }

    if (showMore) {
      return (
        <Target params={params} setParams={setParams} readOnly={readOnly}>
          <SharedConstraintFields
            params={params}
            setParams={setParams}
            readOnly={readOnly}
            validationDef={validationDef}
          />
        </Target>
      );
    }

    return <Target params={params} setParams={setParams} readOnly={readOnly} />;
  };

  return (
    <>
      {/* {!readOnly && (
        <ui.Button
          fullWidth
          sx={uiStyles.fullCardButton}
          color="primary"
          size="small"
          disabled={readOnly}
          onClick={() => setParams({
            type: params.type == 'BOUNDS' ? 'TARGET' : 'BOUNDS',
            target_penalty: params.type == 'BOUNDS' ? 1.0 : undefined,
          })}
        >
          { params.type == 'BOUNDS' ? 'Change to target mode' : 'Change to bounds mode' }
        </ui.Button>
      )} */}
      <mui.core.Box p={3}>
        {form()}
        <mui.core.Box pt={3}>
          <mui.core.Button
            onClick={() => {
              setShowMore(!showMore);
            }}
            color="primary"
            startIcon={showMore ? <mui.icons.Remove /> : <mui.icons.Add />}
          >
            {showMore ? <>Show Less</> : <>Show More</>}
          </mui.core.Button>
        </mui.core.Box>
      </mui.core.Box>
    </>
  );
};

export default NetLeverageConstraint;
